import React from 'react';

import { createNavigationGroupLayoutClassName } from './navigationGroupLayoutStyles';

type Props = {
  titleNode: React.ReactNode;
  linksNode: React.ReactNode;
};

export const NavigationGroupLayout = (props: Props) => {
  const { titleNode, linksNode } = props;

  return (
    <nav className={createNavigationGroupLayoutClassName('wrapper')}>
      <div className={createNavigationGroupLayoutClassName('title-slot')}>
        {titleNode}
      </div>
      <div className={createNavigationGroupLayoutClassName('links-slot')}>
        {linksNode}
      </div>
    </nav>
  );
};
